<template>
    <div class="col-sm-12 editor-form">
        <h2 class="editor-header">{{ contractCollectionUpdate.id && contractCollectionUpdate.id > 0 ? $t('contracts.contract_collection.edit') : $t('contracts.contract_collection.add') }}</h2>
        <div class="col-sm-12 form-data nopads">
            <span class="span-title p-2">
                {{ $t('common.name') }}
            </span>
            <div class="title p-2">
                <input
                    id="name"
                    v-model="contractCollectionUpdate.name"
                    type="text"
                    class="form-control form-control-mb"
                >
            </div>
            <span class="span-title p-2">
                {{ $t('common.description') }}
            </span>
            <div class="title p-2">
                <input
                    id="description"
                    v-model="contractCollectionUpdate.description"
                    type="text"
                    class="form-control form-control-mb"
                >
            </div>
            <span class="span-title p-2">
                {{ $t('menu.contracts') }}
            </span>
            <div class="p-2">
                <multiselect
                    v-model="contractsSelected"
                    :options="contractOptions"
                    :multiple="true"
                    :close-on-select="false"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :selected-label="$t('common.selected')"
                    :select-label="$t('common.select')"
                    :deselect-label="$t('common.remove_selection')"
                    :placeholder="$t('contracts.contract_collection.select_contracts')"
                >
                    <template
                        #singleLabel="props"
                    >
                        <span class="option__desc">
                            <span class="option__title">{{ props.option.text }}</span>
                        </span>
                    </template>
                    <template
                        #option="props"
                    >
                        <div class="option__desc">
                            <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
                        </div>
                    </template>
                    <template #noResult>
                        <span>{{ $t('common.not_found') }}</span>
                    </template>
                    <template #noOptions>
                        <span>{{ $t('common.no_results') }}</span>
                    </template>
                </multiselect>
            </div>
            <!-- Buttons -->
            <div class="col-sm-12 button-container">
                <button
                    class="form-button btn btn-secondary"
                    @click.stop="$emit('close')"
                >
                    {{ $t('common.cancel') }}
                </button>
                <button
                    v-if="contractCollectionUpdate.id && contractCollectionUpdate.id > 0"
                    class="form-button btn btn-danger"
                    @click.stop="confirmDeleteContractCollection"
                >
                    {{ $t('common.remove') }}
                </button>
                <button
                    class="form-button btn btn-success"
                    :disabled="loading"
                    @click.stop="submit()"
                >
                    {{ $t('common.save') }}
                </button>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
        <base-modal
            v-if="deletion"
            size="sm"
            @ok="deleteContractCollection()"
            @close="deletion = false"
        >
            <div class="modal-body">
                <span>{{ $t('common.confirm_delete') }}</span>
            </div>
        </base-modal>
    </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {inject} from "vue";
import BaseModal from "@/components/BaseModal.vue";

export default {
    name: 'ContractCollectionEditor',
    components: {BaseModal},
    mixins: [restApi],
    props: {
        contractCollection: {
            type: Object,
            default: null
        },
        contracts: {
            type: Array,
            default() {
                return []
            }
        },
        contractCollections: {
            type: Array,
            default() {
                return []
            }
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            contractCollectionUpdate: JSON.parse(JSON.stringify(this.contractCollection)),
            contractOptions: [],
            deletion: false,
            contractsSelected: [],
        }
    },
    mounted: function () {
        if(this.contracts && this.contracts.length > 0) {
            this.contractOptions.push({
                value: null,
                text: this.$t('contracts.contract_collection.select_contracts')
            })
            this.contracts.forEach(contract => {
                if(contract.id && contract.name) {
                    this.contractOptions.push({
                        value: contract.id,
                        text: contract.name
                    })
                }
            })
        }
        if(this.contractCollection && this.contractCollection.contracts && this.contractCollection.contracts.length > 0) {
            this.contractCollection.contracts.forEach(contract => {
                this.contractsSelected.push({
                    value: contract.id,
                    text: contract.name
                })
            })
        }
    },
    methods: {
        setDefaultValues: function (contractCollection) {
            if (!contractCollection.name) {
                this.showAlert(this.$t('observation_collections.name_missing'))
                return undefined
            }
            contractCollection.contracts = []
            this.contractsSelected.forEach(contract => {
                contractCollection.contracts.push({id: contract.value, name: contract.text})
            })
            return contractCollection
        },

        submit: function () {
            var json = this.setDefaultValues(this.contractCollectionUpdate)
            if (json !== undefined) {
                this.loading = true
                if(json.id && json.id > 0) {
                    this.restUpdate(this.contractCollectionUrl, json, this.success, this.fail)
                } else {
                    this.restAdd(this.contractCollectionUrl, json, this.success, this.fail)
                }
            }
        },

        deleteContractCollection: function () {
            this.deletion = false
            this.loading = true
            var url = this.contractCollectionUrl + '/' + this.contractCollectionUpdate.id
            this.restDelete(url, this.success, this.fail)
        },

        confirmDeleteContractCollection() {
            if (!this.loading) {
                this.deletion = true
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
